import { useQuery } from "@tanstack/react-query";
import { getTasksDashboard } from "@/modules/tasks/api";
import {
  BasePaginationTasksResponse,
  TasksResponse,
} from "@/modules/tasks/dtos";
import { useMemo } from "react";
import { TaskStatusesBackend } from "@/modules/tasks/enums";

export const useGetTrackTasks = ({ trackUId }: { trackUId?: string }) => {
  const filters = useMemo(() => {
    if (!trackUId) return {};

    return {
      linkedEntitiesUIds: trackUId,
    };
  }, [trackUId]);

  const {
    data: tasksData,
    isLoading,
    isError,
    refetch,
  } = useQuery<BasePaginationTasksResponse<TasksResponse>>({
    queryKey: ["track-tasks", filters],
    queryFn: async () => {
      const response = await getTasksDashboard({
        filters: {
          ...filters,
          status: TaskStatusesBackend.pending,
        },
        pagination: {
          page: 1,
          pageSize: 7,
        },
      });
      return response.data;
    },
    refetchOnWindowFocus: true,
    refetchOnMount: true,
    enabled: !!trackUId,
    staleTime: 0, // Always consider data stale so it refetches on window focus
  });

  return {
    trackTasks: tasksData?.data || [],
    isLoading,
    isError,
    refetch,
  };
};
